/**
 * Related products loader — standard Shopify deferred-recommendations pattern:
 * fetch this section from routes.product_recommendations_url (current product
 * excluded natively, D18) and swap in the rendered strip.
 */
(function () {
  'use strict';

  function init(holder) {
    if (holder.dataset.relatedInit) return;
    holder.dataset.relatedInit = '1';

    var url = holder.getAttribute('data-url');
    if (!url) return;

    var load = function () {
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-related-products]');
          if (fresh && fresh.innerHTML.trim().length) {
            holder.innerHTML = fresh.innerHTML;
            if (window.Dylys && window.Dylys.initProductTiles) {
              window.Dylys.initProductTiles(holder);
            }
          }
        })
        .catch(function () { /* leave the server-rendered fallback in place */ });
    };

    // Defer until near the viewport (the strip sits below the fold)
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          load();
        }
      }, { rootMargin: '400px 0px' });
      observer.observe(holder);
    } else {
      load();
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-related-products]').forEach(init);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
